function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 15.1002V18.1002H7.9L13.8 12.2002L10.8 9.2002L5 15.1002ZM12.2 12.2002L7.5 16.9002H6.2V15.5002L10.8 10.8002L12.2 12.2002Z",
  fill: "#00BB77"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1008 6L11.8008 8.3L14.8008 11.3L17.1008 8.9L14.1008 6ZM14.7008 9.6L13.5008 8.3L14.1008 7.7L15.4008 9L14.7008 9.6Z",
  fill: "#00BB77"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2008 14.5001H17.4008V12.7001C17.4008 12.4001 17.1008 12.1001 16.8008 12.1001C16.5008 12.1001 16.2008 12.4001 16.2008 12.7001V14.5001H14.4008C14.1008 14.5001 13.8008 14.8001 13.8008 15.1001C13.8008 15.4001 14.1008 15.7001 14.4008 15.7001H16.2008V17.5001C16.2008 17.8001 16.5008 18.1001 16.8008 18.1001C17.1008 18.1001 17.4008 17.8001 17.4008 17.5001V15.7001H19.2008C19.5008 15.7001 19.8008 15.4001 19.8008 15.1001C19.8008 14.8001 19.5008 14.5001 19.2008 14.5001Z",
  fill: "#00BB77"
});
const SvgAddVersionIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddVersionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/addVersion_icon.16cc55c4.svg";
export { ForwardRef as ReactComponent };